import { ReactNode } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { ValueLabel } from '..';

export function StyledAutocomplete({
  value,
  labelledby,

  inputValue,
  onInputChange,

  options,
  onChange,

  noOptionsText,
}: {
  value: ValueLabel<string> | null;
  labelledby: string;

  inputValue: string;
  onInputChange: (a: string) => void;

  options: ValueLabel<string>[];

  onChange: (a: string) => void;

  noOptionsText?: ReactNode;
}) {
  return (
    <Autocomplete
      aria-labelledby={labelledby}
      getOptionLabel={option => option.label}
      style={{ width: 300 }}
      renderInput={params => <TextField {...params} variant="outlined" />}
      inputValue={inputValue}
      onInputChange={(e, value) => onInputChange(value)}
      options={options}
      onChange={(e, a) => a !== null && onChange(a.value)}
      noOptionsText={noOptionsText}
      value={value}
      size="small"
    />
  );
}

export function StyledAutocomplete2({
  value,
  labelledby,

  inputValue,
  onInputChange,

  options,
  onChange,

  noOptionsText,
}: {
  value?: string | null;
  labelledby: string;

  inputValue: string;
  onInputChange: (a: string) => void;

  options: string[];

  onChange: (a: string) => void;

  noOptionsText?: ReactNode;
}) {
  return (
    <Autocomplete
      aria-labelledby={labelledby}
      getOptionLabel={option => option}
      style={{ minWidth: 300 }}
      renderInput={params => <TextField {...params} variant="outlined" />}
      inputValue={inputValue}
      onInputChange={(e, value) => onInputChange(value)}
      options={options}
      onChange={(e, a) => a !== null && onChange(a)}
      noOptionsText={noOptionsText}
      value={value}
      size="small"
    />
  );
}
